
export default {
    getData: '/api/web/file/data/query', //获取JSON数据
    saveData: '/api/web/file/data/save', //保存JSON数据
}

